<section class="centered-1170-with-padding py-7">
  @if (data.phoneSection; as section) {
    <div
      class="grid grid-cols-1 gap-y-2 rounded-2xl bg-purple px-5 py-7 desk:grid-cols-[270px_auto] desk:gap-x-10 desk:px-11">
      <app-title [title]="section.title" size="h2" />
      <div class="grid grid-cols-1 gap-y-2 desk:gap-y-0">
        <div class="flex flex-col gap-y-2">
          <div [innerHTML]="section.text" handleHtmlLinks></div>
          <div>{{ section.phonePreamble }}</div>
        </div>
        <div #formStart class="grid grid-cols-1 desk:grid-cols-2">
          @if (callMePhone(); as phone) {
            <div class="flex items-center gap-x-1">
              <app-svg [height]="34" src="assets/icons/phone.svg" />
              <a [href]="phone.telLink" class="cursor-pointer font-title text-[28px] underline desk:text-[35px]">
                {{ phone.formatted }}
              </a>
            </div>
          }
          @if (section.cta; as cta) {
            @if (cta.label) {
              <div class="flex w-full justify-self-end pt-7 desk:mx-0 desk:w-[236px] desk:pt-0">
                <app-button
                  [isFullWidth]="true"
                  [label]="cta.label"
                  [url]="cta.url"
                  leftIconSrc="assets/icons/hearing-impaired-icon.svg" />
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
  @if (data.formSection; as section) {
    <div
      class="mt-5 grid grid-cols-1 rounded-2xl bg-gray-light px-2.5 pb-12 pt-7 desk:grid-cols-[710px_auto] desk:gap-x-8 desk:px-11">
      <div>
        @if (hasSubmittedSuccessfully()) {
          <div
            class="p-5 text-center font-bold desk:flex desk:size-full desk:items-center desk:justify-center desk:text-[24px] desk:leading-6">
            <p>{{ "GLOBAL.FORMS.MESSAGE_RECEIVED_CONFIRMATION" | translate }}</p>
          </div>
        } @else {
          <app-title [title]="section.title" size="h2" />
          <div class="mt-5 grid grid-cols-1 flex-col gap-x-11 gap-y-3 desk:grid-cols-2">
            <div class="flex flex-col gap-y-3">
              @let isSubmitted = isFormSubmitted();
              @let isInvalid = isFormValid().status === "KO";
              @let errors = isFormValid().errors!;
              <div class="relative">
                <label (viewportObserver)="isInputVisible.set($event)" class="mb-1 block font-bold" for="requestType">
                  {{ "GLOBAL.FORMS.LABEL_REQUEST_TYPE" | translate }}
                </label>
                @if (section.requestTypes; as requestTypes) {
                  <app-select
                    (optionSelected)="requestType.set($event)"
                    [displayAsBlock]="true"
                    [options]="requestTypes" />
                }
                @if (isSubmitted && isInvalid && errors.requestType) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.requestType | translate }}
                  </div>
                }
              </div>
              @if (this.isRequestInformationType()) {
                <div class="relative">
                  <label class="mb-1 block font-bold" for="requestType">
                    {{ "GLOBAL.FORMS.LABEL_INFORMATION_TYPE" | translate }}
                  </label>
                  @if (section.requestTypesInformations; as requestTypesInformations) {
                    <app-select
                      (optionSelected)="onRequestTypeInformationSelected($event)"
                      [displayAsBlock]="true"
                      [options]="requestTypesInformations" />
                  }
                  @if (isSubmitted && isInvalid && errors.requestInformationType) {
                    <div class="absolute -bottom-4 text-[10px] text-error">
                      {{ errors.requestInformationType | translate }}
                    </div>
                  }
                </div>
              }
              @if (this.isRequestOrderType()) {
                <div class="relative">
                  <label class="mb-1 block font-bold" for="store">{{ "GLOBAL.FORMS.LABEL_STORE" | translate }}</label>
                  <app-combobox
                    (optionSelected)="onRequestOrderTypeSelected($event)"
                    [displayAsBlock]="true"
                    [options]="stores()" />
                  @if (isSubmitted && isInvalid && errors.requestOrderType) {
                    <div class="absolute -bottom-4 text-[10px] text-error">
                      {{ errors.requestOrderType | translate }}
                    </div>
                  }
                </div>
              }
              <div class="relative">
                <div class="flex gap-x-4">
                  <div class="flex items-center gap-x-2">
                    <input
                      (input)="onInputChange($event)"
                      [checked]="gender() === 'FEMALE'"
                      class="size-5 cursor-pointer"
                      id="genderFemale"
                      name="gender"
                      type="radio"
                      value="FEMALE" />
                    <label class="cursor-pointer" for="genderFemale">
                      {{ "GLOBAL.FORMS.LABEL_TITLE_MADAM" | translate }}
                    </label>
                  </div>
                  <div class="flex items-center gap-x-2">
                    <input
                      (input)="onInputChange($event)"
                      [checked]="gender() === 'MALE'"
                      class="size-5 cursor-pointer"
                      id="genderMale"
                      name="gender"
                      type="radio"
                      value="MALE" />
                    <label class="cursor-pointer" for="genderMale">
                      {{ "GLOBAL.FORMS.LABEL_TITLE_MISTER" | translate }}
                    </label>
                  </div>
                </div>
                @if (isSubmitted && isInvalid && errors.gender) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.gender | translate }}
                  </div>
                }
              </div>
              <div class="relative">
                <label class="mb-1 block font-bold" for="firstName">{{
                  "GLOBAL.FORMS.LABEL_FIRST_NAME" | translate
                }}</label>
                <input
                  (input)="onInputChange($event)"
                  [value]="firstName()"
                  class="h-7 w-full rounded-[10px] border bg-gray-light px-4 py-5"
                  id="firstName"
                  maxlength="255"
                  type="text" />
                @if (isSubmitted && isInvalid && errors.firstName) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.firstName | translate }}
                  </div>
                }
              </div>
              <div class="relative">
                <label class="mb-1 block font-bold" for="lastName">{{
                  "GLOBAL.FORMS.LABEL_LAST_NAME" | translate
                }}</label>
                <input
                  (input)="onInputChange($event)"
                  [value]="lastName()"
                  class="h-7 w-full rounded-[10px] border bg-gray-light px-4 py-5"
                  id="lastName"
                  maxlength="255"
                  type="text" />
                @if (isSubmitted && isInvalid && errors.lastName) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.lastName | translate }}
                  </div>
                }
              </div>
              <div class="relative">
                <label class="mb-1 block font-bold" for="zipcode">{{ "GLOBAL.FORMS.LABEL_ZIPCODE" | translate }}</label>
                <input
                  (input)="onInputChange($event)"
                  [value]="zipcode()"
                  class="h-7 w-full rounded-[10px] border bg-gray-light px-4 py-5"
                  id="zipcode"
                  maxlength="5"
                  type="text" />
                @if (zipcodeNotFound()) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ "GLOBAL.FORMS.ZIPCODE_NOT_FOUND_ERROR" | translate }}
                  </div>
                } @else if (isSubmitted && isInvalid && errors.zipcode) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.zipcode | translate }}
                  </div>
                }
              </div>
              <div class="relative">
                <label class="mb-1 block font-bold" for="city">{{ "GLOBAL.FORMS.LABEL_CITY" | translate }}</label>
                <app-select
                  (optionSelected)="onCitySelected($event)"
                  [disabled]="cityOptions().length < 1"
                  [displayAsBlock]="true"
                  [options]="cityOptions()"
                  id="city" />
                @if (isSubmitted && isInvalid && errors.city) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.city | translate }}
                  </div>
                }
              </div>
            </div>
            <div class="flex flex-col gap-y-3">
              <div class="relative">
                <label class="mb-1 block font-bold" for="phone">{{ "GLOBAL.FORMS.LABEL_PHONE" | translate }}</label>
                <input
                  (input)="onInputChange($event)"
                  [value]="phone()"
                  class="h-7 w-full rounded-[10px] border bg-gray-light px-4 py-5"
                  id="phone"
                  maxlength="16"
                  type="tel" />
                @if (isSubmitted && isInvalid && errors.phone) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.phone | translate }}
                  </div>
                }
              </div>
              <div class="relative">
                <label class="mb-1 block font-bold" for="email">{{ "GLOBAL.FORMS.LABEL_EMAIL" | translate }}</label>
                <input
                  (input)="onInputChange($event)"
                  [value]="email()"
                  class="h-7 w-full rounded-[10px] border bg-gray-light px-4 py-5"
                  id="email"
                  maxlength="255"
                  type="email" />
                @if (isSubmitted && isInvalid && errors.email) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.email | translate }}
                  </div>
                }
              </div>
              <div class="relative">
                <label class="mb-1 block cursor-pointer font-bold" for="message">
                  {{ "GLOBAL.FORMS.LABEL_MESSAGE" | translate }}
                </label>
                <textarea
                  (input)="onInputChange($event)"
                  [value]="message()"
                  class="h-28 w-full rounded-[10px] border bg-gray-light px-4 py-5"
                  id="message"></textarea>
                @if (isSubmitted && isInvalid && errors.message) {
                  <div class="absolute -bottom-4 text-[10px] text-error">
                    {{ errors.message | translate }}
                  </div>
                }
              </div>
              <div class="relative grid grid-cols-2 gap-2">
                <label class="col-span-2 mb-1 block cursor-pointer font-bold" for="message">
                  {{ "GLOBAL.FORMS.LABEL_NEWSLETTER_OPTIN" | translate }}
                </label>
                <div class="flex items-center gap-x-2">
                  <input
                    (input)="onInputChange($event)"
                    [checked]="subscribeEmail()"
                    class="size-5 cursor-pointer"
                    id="subscribeEmail"
                    type="checkbox" />
                  <label class="cursor-pointer" for="subscribeEmail">
                    {{ "GLOBAL.FORMS.LABEL_OPTIN_EMAIL" | translate }}
                  </label>
                </div>
                <div class="flex items-center gap-x-2">
                  <input
                    (input)="onInputChange($event)"
                    [checked]="subscribeSms()"
                    class="size-5 cursor-pointer"
                    id="subscribeSms"
                    type="checkbox" />
                  <label class="cursor-pointer" for="subscribeSms">{{
                    "GLOBAL.FORMS.LABEL_OPTIN_SMS" | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-y-3 desk:col-span-2">
              @if (section.legalNoticeHtml; as legalNoticeHtml) {
                <div
                  [innerHTML]="legalNoticeHtml"
                  class="prose flex max-w-full justify-center py-5 text-[10px] prose-headings:leading-none prose-p:leading-tight"
                  handleHtmlLinks></div>
              }
              <div class="flex justify-center">
                @let buttonLabel = "ACTION.SEND" | translate;
                <app-button (onButtonClick)="onSubmit(buttonLabel)" [isLoading]="isSending()" [label]="buttonLabel" />
              </div>
            </div>
          </div>
        }
      </div>
      <div>
        <div class="relative hidden w-full pt-5 desk:block">
          @if (data.image; as image) {
            <div class="desk:mask-blob-ratio-0_889 absolute">
              <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks" [size]="{ dw: 438, dh: 528 }" />
            </div>
          }
        </div>
      </div>
    </div>
    @if (data.clientSection; as section) {
      <div
        class="mx-5 -mt-8 flex flex-col gap-y-2.5 overflow-hidden rounded-2xl bg-purple px-7 py-6 pl-5 desk:mr-12 desk:w-[308px] desk:justify-self-end">
        <app-title [title]="section.title" size="h2" />
        <div [innerHtml]="section.text" handleHtmlLinks></div>
        @if (section.cta; as cta) {
          <app-button [label]="cta.label" [url]="cta.url" />
        }
      </div>
    }
  }
</section>
